/**
 * Level Card Component
 * Displays a reading level card on the home page
 */

import { Link } from 'react-router-dom'
import type { LevelData } from '@data/books'

interface LevelCardProps {
  level: LevelData
}

export default function LevelCard({ level }: LevelCardProps) {
  const renderStars = () => {
    if (level.isPractice) {
      return <div className="level-card__badge">🚀 Practice Station</div>
    }
    return (
      <div className="level-card__stars">
        {Array.from({ length: level.stars }, (_, i) => (
          <span key={i} className="star">
            ⭐
          </span>
        ))}
      </div>
    )
  }

  return (
    <Link to={level.path} className="level-card">
      <div className="level-card__stars-wrapper">{renderStars()}</div>
      <div className="level-card__content">
        <h2 className="level-card__title">
          {level.isPractice ? '' : (
            <>
              <span className="full-text">{level.name}</span>
              <span className="short-text">{level.shortName}</span>
            </>
          )}
        </h2>
      </div>
      <div className="level-card__image-wrapper">
        <img src={level.thumbnail} alt={level.alt} className="level-card__image" />
      </div>
    </Link>
  )
}
